import { render, staticRenderFns } from "./scanPage.vue?vue&type=template&id=a805b1e6&scoped=true"
import script from "./scanPage.vue?vue&type=script&lang=js"
export * from "./scanPage.vue?vue&type=script&lang=js"
import style0 from "./scanPage.vue?vue&type=style&index=0&id=a805b1e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a805b1e6",
  null
  
)

export default component.exports